export const blikColorSchemeBackgrounds = {
  light: '#ffffff',
  dark: '#2D2D30',
};
